module.exports = __webpack_public_path__ + "static/media/minus.d8093953.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/minus.svg
// module id = 537
// module chunks = 0